// extracted by mini-css-extract-plugin
export default {"combo-box-root":"ComboBox_combo-box-root__na7JE","label":"ComboBox_label__p1-P3","combo-box-wrapper":"ComboBox_combo-box-wrapper__Z85LF","combo-box":"ComboBox_combo-box__dpR6n"};